import { combineReducers } from "redux";
import amcCategoryListAmcReducer from "./AmcCategoryListAmc";
import amcCategoryListCategoryReducer from "./AmcCategoryListCategory";
import exploreEtfListReducer from "./ExploreEtfList";
export default combineReducers({
    amcCategoryListAmcReducer,
    amcCategoryListCategoryReducer,
    exploreEtfListReducer
});
